import { inject, Injectable } from '@angular/core';

import { API_BASE_URL } from './api-url.tokens';

@Injectable({ providedIn: 'root' })
export class ApiUrlService {
  private readonly apiBaseUrl = inject(API_BASE_URL);

  public get baseUrl(): string {
    return this.apiBaseUrl;
  }

  // Auth endpoints
  public get authLogin() {
    return (): string => `${this.baseUrl}/auth/login`;
  }

  public get authLogout() {
    return (): string => `${this.baseUrl}/auth/logout`;
  }

  public get authRefresh() {
    return (): string => `${this.baseUrl}/auth/refresh`;
  }

  public get authMe() {
    return (): string => `${this.baseUrl}/auth/me`;
  }

  public get authForgotPassword() {
    return (): string => `${this.baseUrl}/auth/forgot-password`;
  }

  public get authValidateToken() {
    return (): string => `${this.baseUrl}/auth/validate-token`;
  }

  public get authSetPassword() {
    return (): string => `${this.baseUrl}/auth/set-password`;
  }

  // User endpoints
  public get users() {
    return (): string => `${this.baseUrl}/users`;
  }

  public get user() {
    return (id: string): string => `${this.baseUrl}/users/${id}`;
  }

  public get userResendInvite() {
    return (id: string): string => `${this.baseUrl}/users/${id}/resend-invite`;
  }

  // File endpoints
  public get files() {
    return (): string => `${this.baseUrl}/files`;
  }

  public get file() {
    return (id: string): string => `${this.baseUrl}/files/${id}`;
  }

  public get fileUsage() {
    return (id: string): string => `${this.baseUrl}/files/${id}/usage`;
  }

  // Exercise endpoints
  public get exercises() {
    return (): string => `${this.baseUrl}/exercises`;
  }

  public get exercise() {
    return (id: string): string => `${this.baseUrl}/exercises/${id}`;
  }

  public get exercisesTags() {
    return (): string => `${this.baseUrl}/exercises/tags`;
  }

  // Patient endpoints
  public get patients() {
    return (): string => `${this.baseUrl}/patients`;
  }

  public get patient() {
    return (id: string): string => `${this.baseUrl}/patients/${id}`;
  }

  public get patientRegenerateCode() {
    return (id: string): string => `${this.baseUrl}/patients/${id}/regenerate-code`;
  }

  public get patientRegeneratePseudonym() {
    return (id: string): string => `${this.baseUrl}/patients/${id}/regenerate-pseudonym`;
  }

  public get patientExercises() {
    return (id: string): string => `${this.baseUrl}/patients/${id}/exercises`;
  }

  public get patientStats() {
    return (id: string): string => `${this.baseUrl}/patients/${id}/stats`;
  }
}
